import { createCategoryDependencies } from './categoryPermissionDependencies';

export const applyDirectoryDependencies = createCategoryDependencies({
  categoryName: 'Diretórios',
  basePermissionKeys: ['read:Directory'],
  basePermissionDescriptions: ['Acesso básico'],
  dependentPermissionKeys: ['createModule:Directory', 'editPermissions:Directory'],
  dependentPermissionDescriptions: ['Criar Módulo', 'Editar permissões'],
});

export function useDirectoryRowPermissions() {
  return {
    applyDirectoryDependencies,
  };
}
